import { Messages } from "../Messages";
/** This function is used to get the value for a cell when calculating refiner option counts */
export function getCellDataValue(cell) {
    if (cell === null || cell === "") {
        return "-";
    }
    else if (cell === undefined) {
        return undefined;
    }
    else if (typeof cell === "number" || typeof cell === "string") {
        return cell;
    }
    else if (typeof cell === "boolean") {
        return cell ? Messages.YES.getMessage() : Messages.NO.getMessage();
    }
    else {
        return cell.toString();
    }
}
/** This function is used to generate keys for refiner options */
export function getRefinerOptionKey(cell) {
    if (cell === null || cell === "" || cell === undefined) {
        return "-";
    }
    else if (typeof cell === "number" || typeof cell === "string") {
        return cell;
    }
    else if (typeof cell === "boolean") {
        return cell ? Messages.YES.getMessage() : Messages.NO.getMessage();
    }
    else {
        return cell.toString();
    }
}
